import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../common/components/T';
import uikit from '../../../project/uikit/styles';
import { generateGridStyles } from '../components/helpers';
import { generateUniqueId } from '../../../common/utils/utils';
import { LangContext } from '../../../common/decorators/Language';

const Text = ({ getHandlers, val, gridStyles, name }) => {
    const { translation } = useContext(LangContext) || {};

    const { stylers, classes } = generateGridStyles(gridStyles, name);
    let copy = false;
    if (typeof val === 'string') {
        if (val?.includes(t('copyPage', 'Копия', 'all', translation))) {
            copy = val
                .split(' ')
                .splice(1, val.split(' ').length - 1)
                .join(' ');
        }
    }
    return (
        <p {...getHandlers(false)} className={classes.wrapper} style={stylers.wrapper} key={generateUniqueId()}>
            {copy ? (
                <div style={{ display: 'flex' }}>
                    <p>{copy}</p>
                    <p
                        style={{
                            marginLeft: '8px',
                            background: 'var(--greySuperExtraDarkTransparentColor)',
                            borderRadius: '6px',
                            padding: '4px 6px',
                            ...uikit.small,
                            fontWeight: '500',
                            color: 'var(--greySuperDarkColor)'
                        }}
                    >
                        {t('copyPage', 'Копия', 'all', translation)}
                    </p>
                </div>
            ) : (
                <p style={{ lineHeight: 1.15 }}>
                    {' '}
                    {typeof val === 'object' && !Object.keys(val).length ? '-' : val === 0 ? `${val}` : val}
                </p>
            )}
        </p>
    );
};
Text.propTypes = {
    getHandlers: PropTypes.func,
    gridStyles: PropTypes.object,
    name: PropTypes.string,
    link: PropTypes.string,
    val: PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.string])
};
export default Text;
